export default __webpack_public_path__ + "static/assets/SL-cloud-light.71688399.png";